export default __webpack_public_path__ + "static/media/Selected_Glasses.1c1ce4a9.svg";